import Config from './config';
import FormDesign from './index.vue';

//自定义表单组件
import Custom from './custom/index';

export default {
  install(Vue) {
    Vue.use(Config);
    Vue.use(Custom);
    Vue.component('Avue' + FormDesign.name, FormDesign);
  },
};
